$(function () {

    $(document).on("keydown", ".quote-form", function(event) {
        return event.key != "Enter";
    });

    $('.quote-form input[type=text], .quote-form input[type=number]').change(function () {
        var value = $(this).val();
        if(value.trim() !== ""){
            if($(this).parent().hasClass('has-error')){
                $(this).parent().removeClass('has-error');
            }
            if($(this).next().hasClass('error')){
                $(this).next().remove();
            }
        }
    });

    $('.quote-form select').change(function () {
        if($(this).val() !== ""){
            if($(this).parent().hasClass('has-error')){
                $(this).parent().removeClass('has-error');
            }
            if($(this).next().next().hasClass('error')){
                $(this).next().next().remove();
            }
        }
    });


    $('.quote-type-select input[type=radio]').change(function () {
        let value = $('.quote-type-select input[type=radio]:checked').attr('value');
        if(value == 'product-and-install'){            
           $('div.fieldholder-small.when-to-start-select').slideDown();
        //    $('div.fieldholder-small.when-to-start-select .hidden').removeClass('hidden');

           $('div.fieldholder-small.require-underlay-select').slideDown();
        //    $('div.fieldholder-small.require-underlay-select .hidden').removeClass('hidden');

           $('div.fieldholder-small.kind-of-floor-base-select').slideDown();
        //    $('div.fieldholder-small.kind-of-floor-base-select .hidden').removeClass('hidden');

           $('div.fieldholder-small.uplift-old-flooring-select').slideDown();
        //    $('div.fieldholder-small.uplift-old-flooring-select .hidden').removeClass('hidden');

           $('div.fieldholder-small.us-to-install-for-you-select').slideDown();
        //    $('div.fieldholder-small.us-to-install-for-you-select .hidden').removeClass('hidden');

            // $('div.fieldholder-small.how-to-install-select').slideDown();
            // $('div.fieldholder-small.how-to-install-select .hidden').removeClass('hidden');

           $('#form-widzard .step--2').removeClass('disabled');
        }else{
           $('div.fieldholder-small.when-to-start-select').slideUp();
           $('div.fieldholder-small.require-underlay-select').slideUp();
           $('div.fieldholder-small.kind-of-floor-base-select').slideUp();
           $('div.fieldholder-small.uplift-old-flooring-select').slideUp();
           $('div.fieldholder-small.us-to-install-for-you-select').slideUp();
           // $('div.fieldholder-small.how-to-install-select').slideUp();

           $('div.fieldholder-small.dispose-old-flooring-select').slideUp();
           $('div.fieldholder-small.prepare-the-new-floor-select').slideUp();
           $('div.fieldholder-small.size-of-underlay-select').slideUp();

           $('#form-widzard .step--2').addClass('disabled');
        }
    });

    $('select.us-to-install-for-you-select').change(function () {        
        if($(this).val() === "No" || $(this).val() === ""){
            $('div.fieldholder-small.how-to-install-select').slideUp();
        }else{
            // $('div.fieldholder-small.how-to-install-select .hidden').removeClass('hidden');
            $('div.fieldholder-small.how-to-install-select').slideDown();
        }
    });

    $('select.uplift-old-flooring-select').change(function () {
        if($(this).val() === "No" || $(this).val() === ""){
            $('div.fieldholder-small.dispose-old-flooring-select').slideUp();
        }else{
            $('div.fieldholder-small.dispose-old-flooring-select .hidden').removeClass('hidden');
            $('div.fieldholder-small.dispose-old-flooring-select').slideDown();
        }
    });

    $('select.kind-of-floor-base-select').change(function () {
        if($(this).val() === ""){
            $('div.fieldholder-small.prepare-the-new-floor-select').slideUp();
        }else{
            $('div.fieldholder-small.prepare-the-new-floor-select .hidden').removeClass('hidden');
            $('div.fieldholder-small.prepare-the-new-floor-select').slideDown();
            var html = buildFloorBaseOptions($(this).val());
            $('select.prepare-the-new-floor-select').html(html);
            $('select.prepare-the-new-floor-select').niceSelect('update');
        }

        // TODO should probably have an IsConcrete field on QuoteFormFlooringBaseOption
        if($(this).val() === "Concrete"){
            $('div.fieldholder-small.need-moisture-barrier-select').removeClass('hidden');
            $('div.fieldholder-small.need-moisture-barrier-select .hidden').removeClass('hidden');
            $('div.fieldholder-small.need-moisture-barrier-select').slideDown();
        }else{
            $('div.fieldholder-small.need-moisture-barrier-select').slideUp();
        }
    });

    $('select.require-underlay-select').change(function () {
        if($(this).val() === "No" || $(this).val() === ""){
            $('div.fieldholder-small.size-of-underlay-select').slideUp();
        }else{
            $('div.fieldholder-small.size-of-underlay-select .hidden').removeClass('hidden');
            $('div.fieldholder-small.size-of-underlay-select').slideDown();
        }
    });

    $('.quote-form .material-group__trigger').change(function () {
        if($(this).is(':checked')){
            $(this).parent().find('.material-group__detail').slideDown();
        }else{
            $(this).parent().find('.material-group__detail').slideUp();
        }
    });

    $('.quote-form .finishing-bars-input').change(function () {
        var length = $('input.finishing-bars-input').val();
        var price = roundNumber(length * 10);
        $('.finishing-bars-output-container > span').html(`<label>Install:</label> <price>$${price}</price>`);
    });


    $('.quote-form .vinyl-capped-up-input').change(function () {
        var length = $('input.vinyl-capped-up--length').val();
        length = length == "" ? 0 : parseFloat(length);

        var typeStr = $('select.vinyl-capped-up--type').val();
        var typeUnitPrice = vinylCappedUpPrices[typeStr];
        typeUnitPrice = typeUnitPrice ? typeUnitPrice : 0;

        var price = roundNumber(typeUnitPrice * length);
        $('.vinyl-capped-up-output-container > span').html(`<label>Install:</label> <price>$${price}</price>`);
    });


    $('.quote-form .stair-nosing-input').change(function () {
        var typeStr = $('select.stair-nosing--type').val();
        var typeUnitPrice = stairsNosingPrices[typeStr];
        typeUnitPrice = typeUnitPrice ? typeUnitPrice : 0;

        var number = $('input.stair-nosing--number').val();
        number = number == "" ? 0 : parseFloat(number);

        var installFee = roundNumber(number * typeUnitPrice);

        $('.stair-nosing-output-container > span').html(`<label>Install:</label> <price>$${installFee}</price>`);
    });


    $('.quote-form .rodweld-input').change(function () {
        var number = $('input.rodweld-input--number').val();
        number = number == "" ? 0 : parseFloat(number);

        var installFee = roundNumber(number * 3);

        $('.rodweld-output-container > span').html(`<label>Install:</label> <price>$${installFee}</price>`);
    });


    $('.quote-form .stairs-covering-input').change(function () {
        var width = $('input.stairs-covering--width').val();
        width = width == "" ? 0 : parseFloat(width);
        if(width > 4){
            $('input.stairs-covering--width').val(4);
        }
        var number = $('input.stairs-covering--number').val();
        number = number == "" ? 0 : parseFloat(number);
        var typeStr = $('select.stairs-covering--type').val();
        var typeUnitPrice = vinylStairPrices[typeStr];
        typeUnitPrice = typeUnitPrice ? typeUnitPrice : 0;

        var installFee = roundNumber(number * typeUnitPrice);
        var additionalMaterialSize = (0.25 + 0.25) * width * number;     // (height + depth) * width * number , height = 0.25, depth = 0.25
        //var wastageFee = 0.15 * additionalMaterialSize;                //no need to calculate wastage fee at front end

        additionalMaterialSize = roundNumber(Math.ceil(additionalMaterialSize));

        $('.stairs-covering-output-container > span').html(`<label>Install:</label> <price>$${installFee}</price><br><label>Additional Material:</label> <price>${additionalMaterialSize}m<sup>2</sup></price>`)
    });

    $('.quote-form .btn--add-room').click(function (e) {
        e.preventDefault();
        $(".quote-form .room-dimension:hidden").first().show();
        if($(".quote-form .room-dimension:hidden").length == 0){
            $(this).hide();
        }
    });

    $('input.room-dimension__inputs').change(function () {
        var $parent = $(this).closest('div.room-dimension');
        var width = $parent.find('input.room-dimension__inputs--length').val();
        var length = $parent.find('input.room-dimension__inputs--width').val();
        var size =  roundNumber(width * length);

        $parent.find('.room-dimension__output-container > span').html(`<label>Room Total: </label> <price>${size}m<sup>2</sup></price>`);
    });


    $('.quote-form .btn--next--step1').click(function (e) {
        e.preventDefault();

        $('.quote-form input[type=text]:visible, .quote-form input[type=number]:visible').each(function () {
           if($(this).val().trim() === ""){
               $(this).parent().addClass('has-error');
               if(!$(this).next().hasClass('error')){
                   $(this).after("<div class='error'>Please enter the value</div>");
               }
           }else{
               $(this).parent().removeClass('has-error');
               if($(this).next().hasClass('error')){
                  $(this).next().remove();
               }
           }
        });

        $('.quote-form .nice-select:visible').each(function () {
            if($(this).prev().val().trim() === ""){
                $(this).parent().addClass('has-error');
                if(!$(this).next().hasClass('error')){
                    $(this).after("<div class='error'>Please select an option</div>");
                }
            }else{
                $(this).parent().removeClass('has-error');
                if($(this).next().hasClass('error')){
                    $(this).next().remove();
                }
            }
        });

        if($("div.error:visible").length == 0){
            $('.quote-step--1').hide();
            $("#form-widzard .step").removeClass('current');


            if($("#form-widzard .step--2").hasClass('disabled')){
                $('.quote-step--3').show();
                $("#form-widzard .step--3").addClass('current');
            }else{
                $('.quote-step--2').show();
                $("#form-widzard .step--2").addClass('current');
            }

            scrollToWidard();
        }else{
            scrollToError();
        }
    });




    $('.quote-form .btn--back--step2').click(function (e) {
        e.preventDefault();

        $('.quote-step--2').hide();
        $('.quote-step--1').show();

        $("#form-widzard .step").removeClass('current');
        $("#form-widzard .step--1").addClass('current');

        scrollToWidard();
    });


    $('.quote-form .btn--next--step2').click(function (e) {
        e.preventDefault();
        $('.quote-form input[type=text]:visible, .quote-form input[type=number]:visible').each(function () {
            if($(this).val().trim() === ""){
                $(this).parent().addClass('has-error');
                if(!$(this).next().hasClass('error')){
                    $(this).after("<div class='error'>Please enter the value</div>");
                }
            }else{
                $(this).parent().removeClass('has-error');
                if($(this).next().hasClass('error')){
                    $(this).next().remove();
                }
            }
        });
        $('.quote-form .nice-select:visible').each(function () {
            if($(this).prev().val().trim() === ""){
                $(this).parent().addClass('has-error');
                if(!$(this).next().hasClass('error')){
                    $(this).after("<div class='error'>Please select an option</div>");
                }
            }else{
                $(this).parent().removeClass('has-error');
                if($(this).next().hasClass('error')){
                    $(this).next().remove();
                }
            }
        });

        if($("div.error:visible").length == 0){
            $('.quote-step--2').hide();
            $('.quote-step--3').show();

            $("#form-widzard .step").removeClass('current');
            $("#form-widzard .step--3").addClass('current');

            scrollToWidard();
        }else{
            scrollToError();
        }
    });

    $('.quote-form .btn--back--step3').click(function (e) {
        e.preventDefault();
        $('.quote-step--3').hide();
        $("#form-widzard .step").removeClass('current');


        if($("#form-widzard .step--2").hasClass('disabled')){
            $('.quote-step--1').show();
            $("#form-widzard .step--1").addClass('current');
        }else{
            $('.quote-step--2').show();
            $("#form-widzard .step--2").addClass('current');
        }

        scrollToWidard();
    });

    $('.quote-form .btn--next--step3').click(function (e) {
        e.preventDefault();
        $('.quote-form .room-dimension input[type=number]:visible').each(function () {
            if($(this).val().trim() === ""){
                $(this).parent().addClass('has-error');
                if(!$(this).next().hasClass('error')){
                    $(this).after("<div class='error'>Please enter the value</div>");
                }
            }else{
                $(this).parent().removeClass('has-error');
                if($(this).next().hasClass('error')){
                    $(this).next().remove();
                }
            }
        });

        if($("div.error:visible").length == 0){
            $(this).closest('form').submit();
        }else{
            scrollToError();
        }

    });


    $('.delete-room-link').click(function () {
       $(this).closest('.room-dimension').remove();
    });


});

function roundNumber(num) {
    if(!num){
        return 0;
    }
    return (Math.round(num * 100) / 100).toFixed(2);
}

function scrollToWidard() {
    scrollToElement('marker');
}

function scrollToError() {
    let id = $('.error:visible').first().parent().attr('id');
    if(id){
        scrollToElement(id);
    }
}

function scrollToElement(id) {
    let offsetPosition = $("#" + id).offset().top - $('header .menu-bar').height() - 50;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });

}


function buildFloorBaseOptions(key) {
    var html = '';
    var options = newFloorOptions[key];
    if(options){
        var html = '<option value>--- Please Select ---</option>';
        for (let key in options) {
            html += `<option value="${key}">${options[key]}</option>`;
        }
    }
    for(var i = 0; i < options.length; i++){
        html += `<option>`;
    }
    return html;
}

